import PolicyLayout from './PolicyLayout';
import { CONTACT } from '../constants/contact';
import { COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function TermsOfService() {
  return (
    <PolicyLayout title="Terms of Service">
      <p>
        Effective date: June 13, 2026. By accessing or using <strong>{SITE_DOMAIN}</strong>, operated by{' '}
        {COMPANY_NAME} ({SITE_NAME}), you agree to these Terms of Service. If you do not agree, please discontinue use
        of this website.
      </p>
      <h2>Website Purpose</h2>
      <p>
        This website provides educational content, map update guides, troubleshooting resources, and optional support
        assistance related to automotive, in-dash, and marine GPS navigation devices.
      </p>
      <h2>Brand Independence</h2>
      <p>
        {SITE_NAME} is an independent informational resource. We are not affiliated with, endorsed by, or sponsored by
        any GPS hardware manufacturer or map data provider unless explicitly stated in writing.
      </p>
      <h2>User Responsibility</h2>
      <p>
        You are responsible for verifying device compatibility, firmware requirements, storage availability, and
        backup procedures before applying any map update steps described on this website. Map updates can affect
        device performance if performed incorrectly.
      </p>
      <h2>Permitted Use</h2>
      <p>
        You may use this website for lawful personal or business information purposes. You may not misuse the website,
        attempt unauthorized access, interfere with service operation, or use automated scraping tools without permission.
      </p>
      <h2>Intellectual Property</h2>
      <p>
        Website text, branding, structure, graphics, and design elements are protected by applicable intellectual
        property laws. Reproduction or redistribution without written permission is prohibited.
      </p>
      <h2>Disclaimer</h2>
      <p>
        Content is provided for general informational purposes. We do not guarantee that every update method will work
        for every device model, map region, or software version. Use guidance at your own risk after verifying
        manufacturer instructions.
      </p>
      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, {SITE_NAME} is not liable for indirect, incidental, or consequential
        damages arising from use of this website or reliance on its content, including device malfunction or data loss
        during map updates.
      </p>
      <h2>Changes to Terms</h2>
      <p>
        We may revise these terms at any time. Continued use of the website after updates constitutes acceptance of
        the revised terms. For questions, contact us at <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> or{' '}
        <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phone}</a>.
      </p>
    </PolicyLayout>
  );
}
